export default __webpack_public_path__ + "static/media/illustration-recruit-5-w.3b5b193f.webp";